import React from 'react';
import { Box, Button } from '@mui/material';

const KEYS = [
    ['1', ''], ['2', 'ABC'], ['3', 'DEF'],
    ['4', 'GHI'], ['5', 'JKL'], ['6', 'MNO'],
    ['7', 'PQRS'], ['8', 'TUV'], ['9', 'WXYZ'],
    ['*', ''], ['0', '+'], ['#', ''],
];

/** 3×4 keypad. Used both to type a number and to send DTMF tones during a call. */
const DialPad = ({ onPress, disabled = false, compact = false }) => (
    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: compact ? 0.5 : 1 }}>
        {KEYS.map(([digit, letters]) => (
            <Button
                key={digit}
                variant="outlined"
                color="inherit"
                disabled={disabled}
                onClick={() => onPress(digit)}
                sx={{ flexDirection: 'column', py: compact ? 0.5 : 1, minWidth: 0, lineHeight: 1.1, borderRadius: 2 }}
            >
                <span style={{ fontSize: compact ? 16 : 20, fontWeight: 600 }}>{digit}</span>
                <span style={{ fontSize: 9, opacity: 0.6, letterSpacing: 1, height: 10 }}>{letters}</span>
            </Button>
        ))}
    </Box>
);

export default DialPad;
